import { authHeader, utils } from "../helpers/"

const apiUrl = process.env.REACT_APP_API_URL
const openaiBaseUrl = "https://api.openai.com/v1"

export const chatgptService = {
    getChatGptKey,
    createNewSession,
    sendChat
}

function getChatGptKey() {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    }

    return fetch(`${apiUrl}/api/get-env`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data.OPENAI_API_KEY
        })
}

function createNewSession(model: string, voice: string, instructions: string, apiKey: string) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + apiKey
        },
        body: JSON.stringify({
            model,
            voice,
            modalities: ["audio", "text"],
            input_audio_format: "pcm16",
            output_audio_format: "pcm16",
            turn_detection: {
                type: "server_vad",
                threshold: 0.8, // Very high threshold for maximum noise filtering
                prefix_padding_ms: 300, // Minimal padding to avoid capturing background noise
                silence_duration_ms: 800, // Longer silence detection for better noise filtering
                idle_timeout_ms: 8000, // Reduced from 10000ms to 8000ms for better flow
                create_response: true,
                interrupt_response: false
            },
            input_audio_transcription: {
                model: "whisper-1",
                language: "en",
                prompt: "This is an English learning session. Focus on clear speech and filter out background noise."
            },
            instructions,
            client_secret: {
                expires_after: {
                    anchor: "created_at",
                    seconds: 7200
                }
            }
        })
    }

    return fetch(`${openaiBaseUrl}/realtime/sessions`, requestOptions)
        .then(utils.handleResponse)
        .catch((error) => Promise.reject(error))
}

function sendChat(messages: any[], apiKey: string) {
    const systemMessage = messages.find((msg: any) => msg.role === 'system');

    if (!systemMessage) {
        return Promise.reject(new Error('System message with topic description is required'));
    }

    const systemPrompt = `You are an English language tutor focusing on: "${systemMessage.content}"
    
    Follow these rules:
    1. Keep the conversation focused on the topic described above
    2. You MUST ALWAYS respond in English only, regardless of the user's language
    3. If the user speaks in another language, respond with: "I understand you're speaking in [detected language]. However, let's practice in English. Could you try to express that in English?"
    4. Keep your responses clear, simple, and suitable for language learners
    5. Focus on encouraging English practice and gentle correction
    6. Never switch to any language other than English under any circumstances
    7. If you detect non-English input multiple times, say: "Remember, this is English practice time! I'll help you express yourself in English."
    8. Always stay within the context of the topic: ${systemMessage.content}
    9. Keep responses concise (2-3 sentences) for better conversation flow
    `;

    const messagesWithSystem = messages.filter(msg => msg.role !== 'system');
    messagesWithSystem.unshift({
        role: 'system',
        content: systemPrompt
    });

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + apiKey
        },
        body: JSON.stringify({
            messages: messagesWithSystem,
            model: "gpt-4o",
            temperature: 0.7,
            presence_penalty: 0.6,
            frequency_penalty: 0.5,
            max_tokens: 150,
        })
    };

    return fetch(`${openaiBaseUrl}/chat/completions`, requestOptions)
        .then(utils.handleResponse);
}